import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../res/translations/messages';
import InputErrorMessage from './InputErrorMessage';

const Error = ({reason, reasonParams}) => {
    reason = messages.errors[reason];
    if (!reason) {
        reason = messages.errors.unknown;
    }

    return (
        <InputErrorMessage>
            <FormattedMessage {...reason} values={reasonParams} />
        </InputErrorMessage>
    );
};

export default Error;
